import { render, staticRenderFns } from "./PpmBackground.vue?vue&type=template&id=51ddc6ca&scoped=true"
import script from "./PpmBackground.vue?vue&type=script&lang=ts"
export * from "./PpmBackground.vue?vue&type=script&lang=ts"
import style0 from "./PpmBackground.vue?vue&type=style&index=0&id=51ddc6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddc6ca",
  null
  
)

export default component.exports